import type { EnvironmentId } from "@afar-research/contracts";

import type { ConnectionTarget } from "../connection/model.ts";

export interface ResolvedEnvironmentSettingsSelection {
  readonly target: ConnectionTarget;
  readonly source: "explicit" | "local-default" | "only-environment";
}

function localEnvironmentTarget(targets: Iterable<ConnectionTarget>): ConnectionTarget | null {
  for (const target of targets) {
    if (target._tag === "PrimaryConnectionTarget") return target;
  }
  return null;
}

export function resolveEnvironmentSettingsSelection(
  selectedEnvironmentId: EnvironmentId | null,
  targets: ReadonlyMap<EnvironmentId, ConnectionTarget>,
): ResolvedEnvironmentSettingsSelection | null {
  if (selectedEnvironmentId !== null) {
    const target = targets.get(selectedEnvironmentId);
    return target === undefined ? null : { target, source: "explicit" };
  }

  const target = localEnvironmentTarget(targets.values());
  if (target !== null) return { target, source: "local-default" };
  // Without a local Environment, the only one is the host (the Runtime Web Client's Cloud
  // Workspace). Between several, nothing is guessed: the person chooses.
  const [only, ...others] = targets.values();
  return only !== undefined && others.length === 0
    ? { target: only, source: "only-environment" }
    : null;
}

export function clearRemovedEnvironmentSettingsSelection(
  selectedEnvironmentId: EnvironmentId | null,
  removedEnvironmentId: EnvironmentId,
): EnvironmentId | null {
  return selectedEnvironmentId === removedEnvironmentId ? null : selectedEnvironmentId;
}
